import { createHttpClient } from "./http";

class ColetaRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 30000 });
	}

	getAuthHeader() {
		const token = localStorage.getItem("access_token");
		return { Authorization: `Bearer ${token}` };
	}

	async save(data) {
		return this.axios.post("coleta-distribuidor", data, {
			headers: this.getAuthHeader(),
		});
	}

	async update(data) {
		return this.axios.put("coleta-distribuidor", data, {
			headers: this.getAuthHeader(),
		});
	}

	async getColetasPorData(unidadeDistribuidoraId, data, page = 1, limit = 50, search = "") {
		return this.axios.get("coleta-distribuidor/por-data", {
			params: { unidadeDistribuidoraId, data, page, limit, search },
			headers: this.getAuthHeader(),
		});
	}

	async getColetasAgrupadasPorFornecedor(unidadeDistribuidoraId, data) {
		return this.axios.get("coleta-distribuidor/agrupado-fornecedor", {
			params: { unidadeDistribuidoraId, data },
			headers: this.getAuthHeader(),
		});
	}

	async getEstatisticas(unidadeDistribuidoraId, data) {
		return this.axios.get("coleta-distribuidor/estatisticas", {
			params: { unidadeDistribuidoraId, data },
			headers: this.getAuthHeader(),
		});
	}

	async getResumoSemanal(unidadeDistribuidoraId) {
		return this.axios.get("coleta-distribuidor/resumo-semanal", {
			params: { unidadeDistribuidoraId },
			headers: this.getAuthHeader(),
		});
	}

	async getById(id) {
		return this.axios.get(`coleta-distribuidor/${id}`, {
			headers: this.getAuthHeader(),
		});
	}

	// Retificações feitas pelos fornecedores (WhatsApp) que a unidade ainda não viu.
	async getRetificacoesNaoVistas(unidadeDistribuidoraId) {
		return this.axios.get("coleta-distribuidor/retificacoes", {
			params: { unidadeDistribuidoraId },
			headers: this.getAuthHeader(),
		});
	}

	// Sem ids, marca todas as não vistas da unidade.
	async marcarRetificacoesVistas(unidadeDistribuidoraId, ids) {
		return this.axios.put("coleta-distribuidor/retificacoes/marcar-vistas", { unidadeDistribuidoraId, ids }, {
			headers: this.getAuthHeader(),
		});
	}

	async confirmar(id) {
		return this.axios.put(`coleta-distribuidor/${id}/confirmar`, {}, {
			headers: this.getAuthHeader(),
		});
	}

	async cancelar(id) {
		return this.axios.put(`coleta-distribuidor/${id}/cancelar`, {}, {
			headers: this.getAuthHeader(),
		});
	}

	async changeVisibility(id) {
		return this.axios.put(`coleta-distribuidor/${id}/change-visibility`, {}, {
			headers: this.getAuthHeader(),
		});
	}
}

export default ColetaRepository;
